import { validateEmail } from "../../../utils/validations";


export const validate = (email: string) => {
  if (!validateEmail(email)) return "Por favor escriba un email válido";
};

export const validatePasswords = (password: string, repeatPassword: string) => {
    if (password !== repeatPassword) return "Las contraseñas no coinciden";
  };